import './StatusBadge.css'

const STATUS_CONFIG = {
  pending: { label: 'Pending', color: '#f59e0b' },
  processing: { label: 'Processing', color: '#3b82f6' },
  ready: { label: 'Ready', color: '#8b5cf6' },
  completed: { label: 'Completed', color: '#10b981' },
  cancelled: { label: 'Cancelled', color: '#ef4444' },
  confirmed: { label: 'Confirmed', color: '#10b981' },
  rejected: { label: 'Rejected', color: '#ef4444' },
}

function StatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || { label: status, color: '#6b7280' }

  return (
    <span className="status-badge" style={{ backgroundColor: config.color }}>
      {config.label}
    </span>
  )
}

export default StatusBadge
